export const REGISTRATION_PARAM = 'm2reg';
export const LOG_IN_PARAM = 'm2log';
